/** Remove visit recovery/practice data, preserving other application storage. */
export function clearVisitDrafts(
  storage: Pick<Storage, 'length' | 'key' | 'removeItem'>
) {
  for (let i = storage.length - 1; i >= 0; i--) {
    const key = storage.key(i)
    if (
      key?.startsWith('baseline-draft:') ||
      key?.startsWith('clinic-practice:') ||
      key?.startsWith('clinic-hst-sign:')
    )
      storage.removeItem(key)
  }
}
